export default {
  locale_name: 'tiếng Việt',

  facebook: 'Facebook',
  twitter: 'Twitter',
  insta: 'Instagram',
  telegram: 'Telegram',
  buy: 'Mua',
  sell: 'Bán',
  login: 'Đăng nhập',
  sign_up: 'Gia nhập hội viên',
  profile: 'Trang của tôi',
  logout: 'Đăng xuất',
  home: 'Home',
  asset: 'Tài sản',
  code: 'Mã',
  buy_btn: 'Mua',
  sell_btn: 'Bán',
  not_allow: 'Không thể',
  trade: 'Giao dịch',
  select: 'Lựa chọn',
  cancel: 'Hủy bỏ',
  deposit: 'Nạp tiền',
  withdraw: 'Rút tiền',
  request: 'Đăng ký',
  account: 'Tài khoản',
  status: 'Tình trạng',
  allow: 'Cho phép',
  disallowed: 'Không được phép',
  modify: 'Chỉnh sửa',
  auto: '(Nhập tự động)',
  inquiry: 'Tìm kiếm',
  no_select: '(Không có sự lựa chọn)',
  confirm: 'Được rồi',
  upload_btn: 'Vui lòng thả hoặc bấm vào đây.',
  continue_entry: 'Vui lòng nhập "[+:verification]" bên dưới để tiếp tục.',

  toasted_msg: {
    confirm: 'Đã được xác nhận',
    changed: 'Đã được thay đổi',
    withdrwal: 'Đã được rút khỏi',
    register: 'Đã được đăng ký',
    title: 'Thông báo',
    exchange: 'Đổi tiền trực tiếp đã được xử lý thành công',
    search: 'Đã được tìm kiếm',
    deposit_request: 'Đã được đăng ký nạp tiền',
    withdraw_request: 'Đã được đăng ký rút tiền',
    create_account: 'Tài khoản đã được mở',
    modify: 'Đã được chỉnh sửa',
    cancel: 'Đã bị hủy bỏ',
    trade_confirm: 'Giao dịch đã được ấn định',
    trade_reject: 'Giao dịch đã bị từ chối',
    copy: 'Sao chép',
    nice_msg:
      'Trong trường hợp pop-up chưa được cho phép ở cài đặt trình duyệt việc xác thực danh tính có thể không được tiến hành bình thường.',
    nice_title: 'Hướng dẫn',
    nice_error: 'Không thể xác thực danh tính.',
    no_transfer: 'Không có thông tin trao đổi.',
    email_auth: 'Xác thực email thành công',
    email_auth_send: 'Một email xác thực đã được gửi',
    kyc_withdraw: 'Xác minh tài khoản đã thành công',
    not_allow_trade: 'Giao dịch không hoạt động',
  },
  header: {
    C2C_enroll: 'Đăng ký C2C',
    direct_buy: 'Mua ngay',
    direct_sell: 'Bán ngay',
    wallet_manage: 'Quản lý ví',
    C2C_list: 'Nội dung C2C',
    B2C_list: 'Nội dung B2C',
    withdrawal: 'Nạp tiền/ Rút tiền',
    trade_list: 'Lịch sử giao dịch',
    customer_service: 'Trung tâm khách hàng',
  },
  home_msg: {
    about_title: 'ABOUT RMT',
    about_title_2:
      'RMT tham gia phát triển ngành công nghiệp blockchain Hàn Quốc.',
    about_line_1_1:
      'Sàn giao dịch tiền ảo khái niệm mới dưới hình thức trung chuyển, trao đổi tiền ảo với hiện vật thực chất',
    about_line_1_2:
      'Sàn giao dịch tiền mật mã chọn lọc và niêm yết tiền mật mã đã qua kiểm chứng',
    about_line_1_3:
      'Sàn giao dịch tiền mật mã trên toàn cầu, hỗ trợ nhiều ngôn ngữ khác nhau',
    about_line_2_1:
      'Cung cấp tính bảo mật khiến người sử dụng yên tâm dựa trên hệ thống thiết kế kiến trúc theo hình thức phân tán quy mô lớn và phòng ngừa tấn công từ dịch vụ phân tán (DDOS)',
    about_line_2_2:
      'Cung cấp môi trường giao dịch ổn định và giải pháp quản lý bổ sung tài sản',
    about_line_3_1:
      'Đảm bảo tính ổn định cho việc thanh toán và giao dịch thông qua hệ thống tự kiểm',
    about_line_3_2:
      'Tạo mối quan hệ tin tưởng với khách hàng và cập nhật dịch vụ theo chu kỳ',
    about_line_4_1:
      'Nền tảng crypto được kết nối và tích hợp để có thể sử dụng tài sản mật mã mà không bị giới hạn trực tuyến và ngoại tuyến',
    about_sub_1: 'Trọng tâm',
    about_sub_1_1:
      'Tuân thủ quy định chống rửa tiền và ngăn chặn huy động vốn khủng bố theo bản khuyến nghị của FATF (Financial Action Task Forc) và công ty cung cấp dịch vụ tài sản ảo VASP (Virtual Asset Service Providers) phù hợp với xu hướng khi mà các quy chế toàn cầu ngày càng trở nên mạnh mẽ',
    about_sub_1_2:
      'Hỗ trợ giao dịch ngay tức thì như C2C và B2C trước tình hình những người nắm giữ tiền mật mã tập trung vào giao dịch OTC và mức độ tin cậy của các sàn giao dịch mà có thể giao dịch bị sụt giảm',
    about_sub_2: 'Nội dung đa dạng',
    about_sub_2_1:
      'Sử dụng kiosk, tăng tính tiếp cận để có thể sử dụng ngoại tuyến ở bất cứ nơi đâu',
    about_sub_2_2:
      'Tạo ví theo hình thức thẻ, cực đại hóa tính an toàn và tính tiện lợi',
    about_sub_2_3: 'Điều hành trung tâm thương mại mở trên toàn cầu',
    about_sub_3: 'Tầm nhìn toàn cầu',
    about_sub_3_1:
      'Dự kiến vươn ra ngoài Hàn Quốc, mở rộng dịch vụ sang Trung Quốc, các nước Đông Nam Á, Nhật Bản và châu Âu',
    about_sub_3_2:
      'Phổ cập máy kiosk đã áp dụng trong nước ra nước ngoài như Việt Nam, Philipin. Trở thành sàn giao dịch tiền ảo toàn cầu đi đầu thời đại mới',
    about_side_1: 'Sàn giao dịch tiền mật mã dẫn đầu thế giới ',
    about_side_1_1:
      'Hỗ trợ dịch vụ giao dịch 24/24 một cách nhanh chóng và an toàn',
    about_side_1_2:
      'Cung cấp sự an toàn khi sử dụng dịch vụ escrow và tiến hành giao dịch tiền mật mã',
    about_side_1_3:
      'Hỗ trợ giao dịch nhanh B2C, sử dụng RMT mà không qua bước trung gian',
    about_side_1_4:
      'Giảm áp lực về lệ phí và sự rắc rối của giao dịch OTC, hỗ trợ dịch vụ giao dịch ngoại tuyến an toàn và tiện lợi trong suốt 24h',
    login_register: 'Đăng nhập / Đăng ký',
    trade_guide: 'Xem hướng dẫn giao dịch',
    app_down_1: 'Tải xuống ứng dụng',
    app_down_2:
      'Tiền xu khác nhau, báo giá thời gian thực và giao dịch đơn giản',
    app_down_3: 'Bất cứ lúc nào, bất cứ nơi nào dịch vụ giao dịch thuận tiện',
  },

  footer: {
    about: 'Giới thiệu',
    career: 'Lịch sử phát triển',
    escrow: 'Giao dịch Escrow',
    press: 'Báo chí',
    partner: 'Để trở thành đối tác của chúng tôi',
    help: 'Hỗ trợ khách hàng',
    chat: 'Trò chuyện',
    blog: 'Blog',
    phone: 'Số điện thoại',
    social: 'Xã hội',
  },
  footer_link: {
    about_title: 'Giới thiệu công ty',
    msg_about_1:
      'Tuân thủ quy định chống rửa tiền và ngăn chặn huy động vốn khủng bố theo bản khuyến nghị của FATF (Financial Action Task Force) và công ty cung cấp dịch vụ tài sản ảo VASP (Virtual Asset Service Providers) phù hợp với xu hướng khi mà quy chế toàn cầu đang ngày càng trở nên mạnh mẽ, đồng thời hỗ trợ người sử dụng giao dịch một cách an toàn và suôn sẻ.',
    msg_about_2:
      'Những người nắm giữ tiền mật mã tập trung vào thị trường OTC, mức độ tin cậy của các sàn giao dịch đang sụt giảm. RMT đang hỗ trợ giao dịch ngay tức thì như C2C và B2C phù hợp với sự biến đổi của thời đại',
    msg_about_3:
      'ONE CARD của RMT kết hợp hệ thống ví lạnh để bảo quản tiền ảo trong thiết bị phần cứng mà đã bị chặn.',
    msg_about_4:
      'ONE CARD có thể sử dụng ở máy kiosk phổ biến trong nước, ngoài ra cũng có thể sử dụng sàn giao dịch RMT ngoại tuyến.',
    msg_about_5:
      'Máy kiosk cung cấp nhiều nội dung đa dạng mang tính thực tế như rút tiền mặt, nạp tiền vào tài khoản, đặt vé xem phim, trung tâm thương mại RMT.',
    msg_about_6:
      'RMT hiện đang hỗ trợ nhiều ngôn ngữ đa dạng như tiếng Anh, tiếng Trung, tiếng Nhật và sẽ phổ cập máy kiosk không chỉ trong nước mà còn ở nước ngoài, dẫn đầu xu hướng tín dụng điện tử phù hợp với thời đại.',
    escrow_big_title: 'Giao dịch Escrow',
    msg_escrow_1:
      'Giáo dịch Escrow là dịch vụ bảo vệ tải sản giúp giao dịch giữa người mua và người bán có thể được thực hiện một cách an toàn và suôn sẻ.',
    msg_escrow_2: '-Trình tự giao dịch-',
    msg_escrow_3:
      '1. Nếu hội viên nạp tiền won, hệ thống sẽ bảo quản ở ngân hàng (công ty PG)',
    msg_escrow_4:
      '2. Nếu hội viên đã nạp tiền yêu cầu mua, hệ thống sẽ nạp tiền cho người bán bằng tiền gửi ở ngân hàng (công ty PG).',
    msg_escrow_5:
      '3. Nếu người bán xác nhận tiền, người mua xác nhận xu thì giao dịch được thành lập.',
    msg_escrow_6:
      '4. Trong trường hợp phát sinh vấn đề, căn cứ vào bằng chứng hai bên cung cấp để giải quyết.',
    msg_escrow_7: 'RMT luôn nỗ lực để bảo vệ tài sản của hội viên.',
  },
  account_form: {
    id_place: 'Hãy đăng nhập ID',
    pw_place: 'Hãy đăng nhập mật khẩu',
    forgot_pw: 'Bạn đã quên mật khẩu?',
    confirm_pw: 'Xác nhận mật khẩu',
    name_place: 'Hãy đăng nhập tên',
    email_place: 'Hãy đăng nhập địa chỉ email',
    agree: 'Tôi đồng ý',
    all_agree: 'Tôi đồng ý với mọi người.',
    find_pw: 'Tìm kiếm mật khẩu',
    code_place: 'Hãy nhập mã số nhận được',
  },
  trade_page: {
    b2c_trade: 'Giao dịch B2C',
    select_asset: 'Hãy chọn tài sản',
    select_coin: 'Hãy chọn xu',
    c2c_trade: 'Giao dịch C2C',
    buy_asset: 'Tài sản sẽ mua',
    sell_asset: 'Tài sản để bán',
    purchaser_name: 'Tên người mua',
    seller_name: 'Tên người bán',
    amount: 'Số lượng',
    limit_buy: 'Số lượng mua tối thiểu',
    limit_sell: 'Số lượng bán tối thiểu',
    total_sell_price: 'Tổng số lượng bán hàng',
    buy_price: 'Giá mua',
    sell_price: 'Giá bán',
    regdate: 'Ngày cuối cùng chỉnh sửa thông tin',
    sell_register: 'Đăng ký bán',
    buy_register: 'Đăng ký mua',
    select_c2c_info: 'Thông tin thông báo việc bán đã lựa chọn',
    seller_info: 'Thông tin người bán',
    market_select: 'Lựa chọn thị trường',
    market_title: 'Tên thị trường',
    sell_price_msg: 'Số lượng định bán (0.00000000)',
    min_sell_amount: 'Số lượng bán tối thiểu',
    min_buy_price: 'Số lượng mua tối thiểu',
    min_sell_amount_msg: 'Số lượng mua tối thiểu của đối tác',
    per_sell_price: 'Giá bán theo từng đơn vị',
    per_sell_price_msg: 'Hãy chọn giá đã được chỉ định cho 1.00000000 đơn vị ',
    per_sell_price_msg2:
      'Bạn chỉ cần chọn giá mà bạn muốn nhận cho mỗi đơn vị bán ra',
    select_account: 'Lựa chọn tài khoản sẽ nhận',
    withdraw_account: 'Chọn một tài khoản rút tiền',
    direct_buy_asset: 'Tài sản sẽ mua ngay',
    direct_sell_asset: 'Tài sản để bán ngay lập tức',
    change_target_asset: 'Tài sản mục tiêu hoán đổi',
    source_buy_asset: 'Tài sản mua',
    source_sell_asset: 'Tài sản bán',
    target_change_asset: 'Tài sản hoán đổi',
    b2c_buy_price: 'Giá mua',
    b2c_sell_price: 'giá bán',
    buy_amount: 'Số lượng mua',
    sell_amount: 'Số lượng để bán',
    buy_amount_msg: 'Số lượng định mua 0.00000000',
    per_price: 'Giá theo từng đơn vị',
    per_price_msg: 'Nắm giữ {0} :',
    per_prcie_msg2: 'Giá được hiển thị tự động',
    receive_quantity: 'Số lượng nhận',
    bill_amount: 'số lượng phải trả',
    b2c_buy_title: 'Mua',
    b2c_asset: '{0} sang {1} ',
    b2c_market_price: 'Thời giá',
    b2c_direct_buy: 'Khi mua ngay',
    b2c_direct_sell: 'Khi bán hàng ngay lập tức',
    b2c_exchange_amount: 'Số tiền hoán đổi',
    b2c_amount: 'Số lượng áp dụng',
    b2c_buy: '{0} Mua',
    b2c_sell: '{0}  Bán',
    potential_amount: 'Số lượng khả dụng',
    holding_amount: 'Số lượng bán chưa xác định',
    confirm_amount: 'Số lượng bán đã xác định',
  },
  page_navigation: {
    first_page: 'Trang đầu tiên',
    last_page: 'Trang cuối cùng',
  },
  wallet: {
    asset_value: 'Lượng tài sản nắm giữ của tôi',
    show_currency: 'Xem tất cả tài sản',
    asset_list: 'Mục lục tài sản',
    wallet_list: 'Mục lục tài khoản',
    account_name: 'Tên tài khoản',
    account_number: 'Số tài khoản',
    balance: 'Tiền thừa',
    withdrawal_register: 'Đăng ký nạp tiền/ rút tiền',
    withdrawal_inquiry: 'Tìm kiếm đăng ký nạp tiền/ rút tiền',
    account_register: 'Tạo tài khoản',
    deposit_inquiry: 'Tìm kiếm nạp tiền',
    withdraw_inquiry: 'Tìm kiếm rút tiền',
    account_modify: 'Chỉnh sửa tài khoản',
    deposit_price: 'Số tiền nạp',
    deposit_register: 'Đăng ký nạp tiền',
    withdraw_register: 'Đăng ký rút tiền',
    withdraw_price: 'Số tiền rút',
    account_seq: 'Số tài khoản vốn có',
    regdate: 'Ngày mở tài khoản',
    hold_balance: 'Số tiền bị giữ',
    selected_asset: 'Tài sản lựa chọn',
    before_regdate: '(Trước khi mở tài khoản)',
    open: 'Mở',
    address_title: 'thông tin địa chỉ tài khoản',
    account_address: 'địa chỉ tài khoản',
    create_account_address: 'Mở địa chỉ tài khoản',
    deposit_msg: 'Gửi {0} từ ví bên ngoài vào ví {0} của tôi.',
    deposit_msg_1:
      'Sau khi được chấp thuận 350 lần trên blockchain, nó sẽ được phản ánh trong ví giao dịch {0} của bạn.',
    deposit_step_1: 'Vui lòng kiểm tra BƯỚC 1. {0} ID ghi nhớ trước.',
    deposit_step_1_1: 'ID ghi chú {0} của tôi',
    deposit_step_1_2:
      'Khi gửi {0} ID ghi chú duy nhất của bạn phải được bao gồm. {0} được gửi mà không có ID ghi chú sẽ bị mất.',
    deposit_step_1_3: 'Tôi đã xác nhận nó. Xem địa chỉ ví {0} của tôi',
    deposit_step_1_btn: 'Tạo ID ghi chú',
    deposit_step_2: 'BƯỚC 2. Vui lòng kiểm tra địa chỉ ví của tôi.',
    deposit_step_2_1: 'Mã QR',
    deposit_step_2_2: 'Địa chỉ ví',
    deposit_step_2_3:
      'Số tiền ký gửi tối thiểu là <span style = "color: # 4a90e2"> {0} {1} </ span>.',
    deposit_step_2_btn: 'Sao chép địa chỉ ví',
    deposit_msg_2: 'Vui lòng xác nhận',
    deposit_msg_2_1: 'Địa chỉ trên chỉ dành cho tiền gửi.',
    deposit_msg_2_2:
      'Tổng thời gian để hoàn thành xác nhận có thể bị ảnh hưởng bởi sự tắc nghẽn của mạng blockchain và tắc nghẽn blockchain bởi tiền điện tử là <span style = "color: # 4a90e2; con trỏ: con trỏ;"> tại đây </ span> Bạn có thể kiểm tra.',
  },
  private: {
    my_deal_list: 'Danh sách bán hàng của tôi',
    my_app_list: 'Danh sách mua hàng của tôi',
    source_asset: 'Tài sản nguồn',
    target_asset: 'Tài sản mục tiêu',
    source_amount: 'Số lượng tài sản nguồn',
    regdate: 'Ngày thông báo',
    source_max_amount: 'Số lương tối đa',
    source_min_amount: 'Số lượng tối thiểu',
    max_price: 'Giới hạn ra giá tối đa',
    min_price: 'Giới hạn ra giá tối thiểu',
    close_date: 'Ngày kết thúc',
    app_inquiry_cancel: 'Tìm kiếm/ Hủy bỏ lịch sử mua',
    app_name: 'Tên người mua',
    per_price: 'Giá theo số lượng',
    confirm_reject: 'Ấn định/ Từ chối',
    confirm: 'Xác nhận',
    reject: 'Từ chối',
    fee_amount: 'Tổng lệ phí',
    request_cancel: 'Hủy đăng ký',
    b2c_source_asset: 'Tài sản nguồn',
    b2c_target_asset: 'Tài sản mục tiêu',
    b2c_source_amount: 'Số lượng tài sản nguồn',
    b2c_target_amount: 'Số lượng tài sản mục tiêu',
    basic_rate: 'Tỷ lệ tiêu chuẩn giao dịch áp dụng',
    spread_rate: 'Tỷ lệ lan truyền bảo hiểm',
    exchange_rate: 'Tỷ giá hối đoái áp dụng',
    source_account: 'Số tài khoản tài sản tham chiếu',
    target_account: 'Số tài khoản tài sản tương đối',
    fee_rate: 'Lệ phí',
    fee_calc: '{0} cái được trừ đi',
    b2c_buy_asset: 'tài sản mua hàng',
    b2c_sell_asset: 'tài sản bán',
    b2c_buy_amount: 'số lượng tài sản mua hàng',
    b2c_sell_amount: 'Số lượng tài sản bán hàng',
    b2c_last_buy_amount: 'Giá mua cuối cùng',
    b2c_last_sell_amount: 'Giá bán cuối cùng',
  },
  withdrawal: {
    deposit_list: 'Lịch sử đăng ký nạp tiền',
    withdraw_list: 'Lịch sử đăng ký rút tiền',
    asset_name: 'Tên tài sản',
    request_price: 'Số tiền đề nghị',
    deposit_inquiry_cancel: 'Tìm kiếm/ Hủy bỏ lịch sử nạp tiền',
    withdraw_inquiry_cancel: 'Tìm kiếm/ Hủy bỏ lịch sử rút tiền',
    history_detail: 'Lịch sử cụ thể',
    regdate: 'Ngày đăng ký',
  },
  myprofile: {
    profie: 'Thông tin hội viên',
    user_name: 'Tên người sử dụng',
    email: 'Email',
    regdate: 'Ngày gia nhập',
    last_login: 'Đăng nhập gần đây',
    kyc_cert: 'Chứng nhận KYC',
    kyc_cert_request: 'Đăng ký chứng nhận',
    kyc_cert_list: 'Lịch sử đăng ký',
    pw_modify: 'Chỉnh sửa mật khẩu',
    old_pw: 'Vui lòng nhập mật khẩu cũ của bạn',
    new_pw: 'Vui lòng nhập mật khẩu mới',
    confirm_pw: 'Xác nhận mật khẩu',
    email_modify: 'Chỉnh sửa email',
    new_email: 'Vui lòng nhập một email mới',
    withdrawal: 'Rút khỏi tài khoản',
    modal_msg: 'Hãy đăng nhập mật khẩu để rút khỏi',
    authority: 'Xác thực danh tính',
    complete_auth: 'Hoàn thành xác thực',
    authenticate: 'Tiến hành xác thực',
    uid: 'ID thành viên (UID)',
    email_auth: 'xác thực email',
    auth: 'xác thực',
    auth_code_send: 'gửi mã xác minh',
    auth_code: 'mã xác thực',
    auth_code_msg: 'Vui lòng nhập mã xác minh của bạn trong vòng 5 phút',
    otp_auth: 'Xác thực OTP',
    enroll: 'ghi danh',
    security: 'cấp độ bảo mật',
    security_view: 'xem mức độ bảo mật',
    withdraw_auth: 'xác thực địa chỉ rút tiền',
  },
  kyc: {
    kyc_title: 'Chứng nhận KYC',
    regdate: 'Ngày đăng ký',
    expdate: 'Ngày hết hạn',
    detail: 'Cụ thể',
    type_title: 'Nhập tên',
    withdraw_auth: 'xác thực địa chỉ rút tiền',
    select_asset: 'chọn tài sản',
    select_bank: 'chọn ngân hàng',
    holder_name: 'tên của người giữ',
    birth: '6 chữ số sinh',
    address: 'địa chỉ tài sản',
    withdraw_list: 'ứng dụng tài khoản rút tiền',
    bank_name: 'tên ngân hàng',
    withdraw_info: 'thông tin tài khoản rút tiền',
    withdraw_complete: 'Các tài sản đã được chứng nhận.',
  },
  otp: {
    enter_verification_number: 'Nhập số xác minh OTP của bạn',
    otp_management: 'Quản lý OTP',
    authenticode: 'Khóa OTP',
    otp_deactivate: 'OTP hủy kích hoạt',
    msg_authenticator_installation:
      'Vui lòng cài đặt ứng dụng "Google Authenticator" trên điện thoại thông minh hoặc máy tính để bàn của bạn',
    android: 'android',
    or: 'hoặc',
    iphone_series: 'iPhone, iPad và iPod',
    windows_phone: 'Điện thoại Windows',
    and: 'và',
    msg_microsoft_other_systems:
      'Các hệ thống khác, bao gồm cả máy tính để bàn Microsoft Windows',
    msg_key: 'khóa này',
    msg_use_loss_change:
      'Viết trên giấy. Được sử dụng khi bạn mất thiết bị hoặc cần thay đổi OTP. ',
    msg_brcode_touch:
      'Khởi chạy ứng dụng "Google Authenticator" và nhấn <b> Quét mã vạch QR </ b> ở cuối màn hình.',
    msg_input_authenticode:
      'Vui lòng nhập mã xác thực được hiển thị trên màn hình trong trường "Mã xác thực" bên dưới.',
    otp_key: 'Khóa OTP',
    otp_activate: 'Kích hoạt OTP',
    otp_copy: 'Sao chép khóa OTP',
    otp_safe_keeping:
      'Bạn đã viết khóa OTP trên giấy và lưu trữ ở nơi an toàn chưa?',
    yes: 'có',
    otp_register: 'đăng ký',
    otp_register_success: 'Hoàn tất đăng ký OTP',
    otp_delete_success: 'Đăng ký xóa OTP đã hoàn tất thành công.',
    msg_click_key_copy: 'Bấm để sao chép khóa',
    otp_login: 'Đăng nhập OTP',
  },
  security: {
    security_auth: 'xác thực bảo mật',
    grade: 'lớp',
    condition: 'điều kiện',
    restriction: 'hạn chế',
    no_grade: 'unrated',
    no: 'không',
    security_title: 'Hạn chế theo điều kiện về mức độ bảo mật',
  },
  notice_modal: {
    title: 'Thông báo',
    content:
      'Đây là một RMT định giá tài sản của khách hàng của chúng tôi. Để đảm bảo giao dịch ổn định, chúng tôi sẽ chỉ tiến hành đăng ký thành viên.',
    check: 'Không thấy trong một ngày',
  },
}
